module.exports = __webpack_public_path__ + "static/media/7.eca6f32d.mp4";